import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useRef, useMemo } from 'react';
import { useIntersection, useMeasure } from 'react-use';
import CircularProgress from '@mui/material/CircularProgress';
import responsiveUtils from '@/utils/responsive';
import { ButtonV2 as Button } from '@/components/Button';
import SegmentedControl, { Segment } from '@/components/SegmentedControl';
import Label from '@/components/FormElements/Label';
import Select from '@/components/FormElements/Select';
import ModalHoc from '@/components/ModalHoc';
import * as MegaSelect from '@/components/FormElements/MegaSelect';
import modalStyles from '@/components/ModalHoc/styles.module.scss';
import displayModalStyles from '@/components/ModalHoc/stylesDisplay.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var CloudDownloadIcon = function CloudDownloadIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M14.4676 7.50406L15.0191 8.45912L16.1211 8.50237C17.7211 8.56517 19 9.88371 19 11.5C19 13.1569 17.6569 14.5 16 14.5C15.4477 14.5 15 14.9477 15 15.5C15 16.0523 15.4477 16.5 16 16.5C18.7614 16.5 21 14.2614 21 11.5C21 8.80541 18.8685 6.60867 16.1996 6.50391C15.1627 4.70835 13.2225 3.5 11 3.5C8.14631 3.5 5.75793 5.49223 5.1498 8.16173C3.8602 8.95305 3 10.3761 3 12C3 14.4853 5.01472 16.5 7.5 16.5H8C8.55228 16.5 9 16.0523 9 15.5C9 14.9477 8.55228 14.5 8 14.5H7.5C6.11929 14.5 5 13.3807 5 12C5 11.1001 5.47415 10.3092 6.19581 9.86639L6.91295 9.42634L7.09984 8.60596C7.5052 6.82657 9.10007 5.5 11 5.5C12.4791 5.5 13.7733 6.3018 14.4676 7.50406Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 10.4167C13 9.91041 12.5523 9.5 12 9.5C11.4477 9.5 11 9.91041 11 10.4167V18.0858L10.7071 17.7929C10.3166 17.4024 9.68342 17.4024 9.29289 17.7929C8.90237 18.1834 8.90237 18.8166 9.29289 19.2071L11.2929 21.2071C11.6834 21.5976 12.3166 21.5976 12.7071 21.2071L14.7071 19.2071C15.0976 18.8166 15.0976 18.1834 14.7071 17.7929C14.3166 17.4024 13.6834 17.4024 13.2929 17.7929L13 18.0858V10.4167Z",
      fill: "white"
    })]
  }));
};

CloudDownloadIcon.defaultProps = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CrownIcon = function CrownIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_8841_1625)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M2.00049 13H16.0005V17C16.0005 17.5523 15.5528 18 15.0005 18H3.00049C2.4482 18 2.00049 17.5523 2.00049 17V13Z",
        fill: "#C3C9D1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.00872128 2.13694C-0.0702641 1.70613 0.40354 1.38918 0.771584 1.62662L5.54637 4.70708C5.79121 4.86504 6.11872 4.78102 6.25728 4.52469L8.56051 0.263706C8.74952 -0.0859494 9.25122 -0.0859485 9.44022 0.263707L11.7435 4.52469C11.882 4.78102 12.2095 4.86504 12.4544 4.70708L17.2291 1.62662C17.5972 1.38918 18.071 1.70613 17.992 2.13694L16.0004 13H2.00037L0.00872128 2.13694Z",
        fill: "black"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8841_1625",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18.0007",
          height: "18",
          fill: "white"
        })
      })
    })]
  }));
};

CrownIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export const SHARE_MODAL_FOOTER_ID = 'share-modal-footer';
const SHARE_OPTIONS = ['free_image_video', 'public_view_link', 'wordpress_embed_link', 'notion_embed_link'];

const EditorChartShareModal = _ref => {
  let {
    widget,
    shareType,
    size,
    fileType,
    isSharing,
    hidePremiumOptions,
    previewImageUrl,
    onDownloadImage,
    onDownloadVideo,
    onShareTypeChange,
    onSizeChange,
    onFileTypeChange
  } = _ref;
  const lastOptionIntersectionRef = useRef(null);
  const lastOptionIntersection = useIntersection(lastOptionIntersectionRef, {
    root: null,
    rootMargin: '0px',
    threshold: 1
  });
  const [containerEl, {
    width
  }] = useMeasure();
  const isSingleColLayout = useMemo(() => responsiveUtils.isMediumOrSmaller(width), [width]);
  const isVideo = fileType === 'webm';
  return /*#__PURE__*/_jsxs("div", {
    ref: containerEl,
    className: clsx(displayModalStyles.container, !isSingleColLayout ? styles['container--twoCols'] : ''),
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx(displayModalStyles.main, styles.main),
      children: previewImageUrl ? /*#__PURE__*/_jsx("div", {
        className: styles.previewImage,
        children: /*#__PURE__*/_jsx("img", {
          src: previewImageUrl,
          alt: "Preview"
        })
      }) : /*#__PURE__*/_jsx("div", {
        children: "Loading..."
      })
    }), /*#__PURE__*/_jsxs("aside", {
      className: clsx(displayModalStyles.sidebar, styles.sidebar),
      children: [/*#__PURE__*/_jsxs("header", {
        className: styles.sidebar__header,
        children: [/*#__PURE__*/_jsx("h5", {
          className: styles.heading,
          children: "Chart Share Options"
        }), /*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: "Customize your free download or embed as an interactive, realtime, block on any web platform."
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: clsx(styles.sidebar__main, {
          [styles['sidebar__main--hasScroll']]: !(lastOptionIntersection !== null && lastOptionIntersection !== void 0 && lastOptionIntersection.isIntersecting)
        }),
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.sidebar__main__content,
          children: [/*#__PURE__*/_jsx(ShareOptions, {
            value: shareType,
            hidePremiumOptions: hidePremiumOptions,
            onChange: onShareTypeChange
          }), /*#__PURE__*/_jsx("div", {
            ref: lastOptionIntersectionRef
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        id: SHARE_MODAL_FOOTER_ID,
        className: styles.sidebar__footer,
        children: shareType === 'free_image_video' ? /*#__PURE__*/_jsx(ImageShareForm, {
          widgetId: widget.id || '',
          size: size,
          fileType: fileType,
          isLoading: isSharing,
          onSizeChange: onSizeChange,
          onFileTypeChange: onFileTypeChange,
          onDownload: isVideo ? onDownloadVideo : onDownloadImage
        }) : /*#__PURE__*/_jsx(_Fragment, {})
      })]
    })]
  });
};

const ShareOptions = props => {
  return /*#__PURE__*/_jsx(MegaSelect.Root, {
    alwaysVisible: true,
    value: props.value ?? '',
    onValueChange: props.onChange,
    children: /*#__PURE__*/_jsx(MegaSelect.Content, {
      variant: "inline",
      children: /*#__PURE__*/_jsxs(MegaSelect.Group, {
        children: [/*#__PURE__*/_jsx(MegaSelect.Option, {
          label: "Free File Download",
          description: "Download your free image or video, no signup required.",
          value: "free_image_video",
          image: "/img/share/free-image-video.webp"
        }), !props.hidePremiumOptions ? /*#__PURE__*/_jsx(MegaSelect.Option, {
          label: "Public View Link",
          description: "Create a public view link to allow anyone to access an interactive chart.",
          value: "public_view_link",
          image: "/img/share/public-view-link.webp",
          icon: /*#__PURE__*/_jsx(CrownIcon, {})
        }) : null, /*#__PURE__*/_jsx(MegaSelect.Option, {
          label: "Wordpress Embed",
          description: "Embed this chart on your Wordpress site as a, realtime, interactive block.",
          value: "wordpress_embed_link",
          image: "/img/share/wordpress-embed.webp",
          icon: props.hidePremiumOptions ? undefined : /*#__PURE__*/_jsx(CrownIcon, {})
        }), !props.hidePremiumOptions ? /*#__PURE__*/_jsx(MegaSelect.Option, {
          label: "Notion Embed Link",
          description: "Create a link to embed this chart in Notion an interactive block with realtime data.",
          value: "notion_embed_link",
          image: "/img/share/notion-embed-link.webp",
          icon: /*#__PURE__*/_jsx(CrownIcon, {})
        }) : null]
      })
    })
  });
};

const ImageShareForm = _ref2 => {
  let {
    widgetId,
    fileType,
    size,
    isLoading,
    onFileTypeChange,
    onSizeChange,
    onDownload
  } = _ref2;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.controls,
    children: [/*#__PURE__*/_jsxs(SegmentedControl, {
      defaultValue: size,
      className: styles.sizeControl,
      onChange: onSizeChange,
      children: [/*#__PURE__*/_jsx(Segment, {
        label: "1x Size",
        value: "size_1x"
      }), /*#__PURE__*/_jsx(Segment, {
        label: "2x Size",
        value: "size_2x"
      }), /*#__PURE__*/_jsx(Segment, {
        label: "3x Size",
        value: "size_3x"
      })]
    }), /*#__PURE__*/_jsx(Label, {
      forInput: `${widgetId}-file-type`,
      className: styles.formField,
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: ["File Type", /*#__PURE__*/_jsxs(Select, {
          id: `${widgetId}-file-type`,
          defaultValue: fileType,
          disabled: isLoading,
          onChange: _ref3 => {
            let {
              currentTarget
            } = _ref3;
            return currentTarget && onFileTypeChange(currentTarget.value);
          },
          children: [/*#__PURE__*/_jsx("option", {
            value: "png",
            children: "PNG"
          }), /*#__PURE__*/_jsx("option", {
            value: "webp",
            children: "WEBP"
          }), /*#__PURE__*/_jsx("option", {
            value: "jpg",
            children: "JPEG"
          }), /*#__PURE__*/_jsx("option", {
            value: "webm",
            children: "VIDEO"
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.formField,
      children: /*#__PURE__*/_jsx("div", {
        className: styles.shareButtons,
        children: /*#__PURE__*/_jsx(Button, {
          size: "large",
          variant: "primary",
          className: styles.button,
          leftIcon: isLoading ? /*#__PURE__*/_jsx(CircularProgress, {
            size: 20,
            color: "inherit"
          }) : /*#__PURE__*/_jsx(CloudDownloadIcon, {}),
          disabled: isLoading,
          onClick: onDownload,
          children: "Download"
        })
      })
    })]
  });
};

export default ModalHoc(EditorChartShareModal, {
  modalClass: modalStyles['container--big'],
  overlayclass: modalStyles['overlay--high']
});